import PropTypes from 'prop-types';
import * as R from 'ramda';
import React, {Component} from 'react';
import classNames from 'classnames';

import './index.scss';

export default class CsvForm extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        onSubmit: PropTypes.func.isRequired,
        isLoading: PropTypes.bool.isRequired,
        isErrored: PropTypes.bool.isRequired,
        message: PropTypes.string,
        buttonText: PropTypes.string
    };

    static defaultProps = {
        buttonText: 'Upload CSV',
        message: null
    };

    constructor(props) {
        super(props);

        this.state = {
            noFileSelected: true
        };
    }

    onSubmit = R.pipe(
        R.tap(e => e.preventDefault()),
        this.props.onSubmit
    );

    updateNoFileSelected = e => {
        this.setState({
            noFileSelected: e.target.files.length < 1
        });
    };

    render() {
        const {children, buttonText, isLoading, isErrored, message} = this.props;

        const {noFileSelected} = this.state;

        return (
            <form
                method="post"
                acceptCharset="UTF-8"
                action="#"
                encType="multipart/form-data"
                onSubmit={this.onSubmit}
                className="form-inline csv-upload-form"
            >
                <div className="form-group">
                    <label htmlFor="csv" className="csv-upload-form__label">
                        CSV File
                    </label>
                    <input
                        className="form-control csv-upload-form__file"
                        name="csv"
                        id="csv"
                        type="file"
                        onChange={this.updateNoFileSelected}
                    />
                </div>
                <div className="form-group">
                    <button
                        type="submit"
                        className="btn btn-primary csv-upload-form__submit"
                        disabled={isLoading || noFileSelected}
                    >
                        {!isLoading ? (
                            buttonText
                        ) : (
                            <i className="fa fa-refresh fa-spin fa-fw" aria-hidden="true" />
                        )}
                    </button>
                </div>
                {message && (
                    <div
                        className={classNames('csv-upload-form__message', {
                            'csv-upload-form__message--errored': isErrored,
                            'csv-upload-form__message--success': !isErrored
                        })}
                    >
                        {message}
                    </div>
                )}
                <hr />
                <div className="help-block">{children}</div>
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./components/csv_upload_form/index.js